import PageLayout from "layouts/PageLayout";
import TableData from "./tableData";

function Orders() {
  return (
    <PageLayout
      title={'Orders'}
    >
      <TableData />
    </PageLayout>
  );
}

export default Orders;
